import { CSSObject } from '@chakra-ui/react';

export const LoginButton: CSSObject = {
  bg: 'beta.500',
  boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.15)',
  fontSize: 'xs',
  _hover: {
    bg: 'beta.700',
  },
  _active: {
    bg: 'beta.100',
  },
};

export const LinkSignup: CSSObject = {
  display: 'none',
};

export const LinkForgotPassword: CSSObject = {
  color: 'red.500',
  fontSize: '2xs',
  fontWeight: 'medium',
};
